// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderRowContainer":"TableHeaderRow__tableHeaderRowContainer--1eR","tableHeaderRowColumn":"TableHeaderRow__tableHeaderRowColumn--2_M"};